export default {
    template: '#auth-init',
    props: ['title'],
    data() {
        return {
        }
    },
    methods: {
    }
}